import gwFetchInstance from "./apiHelper"
import { TECHPOINT_MMS, TECHPOINT_BUSINESS_MMS } from "../utils/const/base-url";
import { GET, POST } from "../utils/const/http-method";

const apiService = {
    getEnvironmentData() {
        return gwFetchInstance
            .send(TECHPOINT_MMS + "/services/envs", {
                method: GET,
            })
            .then((res) => res.json());
    },

    getBlueprintCategoryData() {
        return gwFetchInstance
            .send(TECHPOINT_MMS + "/services/getAllBlueprintsCategory", {
                method: GET,
            })
            .then((res) => res.json());
    },

    getBlueprints() {
        return gwFetchInstance
            .send(TECHPOINT_MMS + "/services/blueprints", {
                method: GET,
            })
            .then((res) => res.json());
    },

    getAllBlueprints() {
        return gwFetchInstance
            .send(TECHPOINT_MMS + "/services/getAllBlueprints", {
                method: GET,
            })
            .then((res) => res.json());
    },

    getBlueprintById(blueprintId) {
        return gwFetchInstance
            .send(TECHPOINT_MMS + "/services/blueprints/" + blueprintId, {
                method: GET,
            })
            .then((res) => res.json());
    },

    createBlueprint(blueprint) {
        return gwFetchInstance.send(
            TECHPOINT_MMS + "/services/createBlueprint",
            {
                method: POST,
                headers: {
                    "content-type": "application/json",
                },
                body: JSON.stringify(blueprint),
            }
        ).then((res) => res.status);
    },

    getCloudTypes() {
        return gwFetchInstance
            .send(TECHPOINT_MMS + "/services/getCloudTypes", {
                method: GET,
            })
            .then((res) => res.json());
    },

    getBlueprintsCategories() {
        return gwFetchInstance
            .send(TECHPOINT_MMS + "/services/getBlueprintsCategories", {
                method: GET,
            })
            .then((res) => res.json());
    },

    getAllApplicationUserRoles() {
        return gwFetchInstance
            .send(TECHPOINT_MMS + "/services/getAllApplicationUserRoles", {
                method: GET,
            })
            .then((res) => res.json());
    },

    getUser() {
        return gwFetchInstance
            .send(TECHPOINT_BUSINESS_MMS + "/services/getUser", {
                method: GET,
            })
            .then((res) => res.json());
    },

    getRegions() {
        return gwFetchInstance
            .send(TECHPOINT_MMS + "/services/regions", {
                method: GET,
            })
            .then((res) => res.json());
    },

    getPillars() {
        return gwFetchInstance
            .send(TECHPOINT_MMS + "/getPillars", {
                method: GET,
            })
            .then((res) => res.json());
    },

    getSubPillars() {
        return gwFetchInstance
            .send(TECHPOINT_MMS + "/getSubPillars", {
                method: GET,
            })
            .then((res) => res.json());
    },

    getUserDataSF() {
        return gwFetchInstance
            .send(TECHPOINT_MMS + "/getUserDataSF", {
                method: GET,
            })
            .then((res) => res.json());
    },

    getTechnicalEngagementByOpptId(opportunityID) {
        return gwFetchInstance
            .send(TECHPOINT_MMS + "/getTechnicalEngagementByOpptId?opportunityID='" + opportunityID + "'", {
                method: GET,
            })
            .then((res) => res.json());
    },

    getTechnicalEngagementByAccountId(accountID) {
        return gwFetchInstance
            .send(TECHPOINT_MMS + "/getTechnicalEngagementByAccountId?accountID='" + accountID + "'", {
                method: GET,
            })
            .then((res) => res.json());
    },

    getOpportunitiesById(accountId) {
        return gwFetchInstance.send(
            TECHPOINT_MMS + "/getOpportunitiesById",
            {
                method: POST,
                headers: {
                    "content-type": "application/json",
                },
                body: JSON.stringify({"accountId":accountId}),
            }).then((res)=>res.json());

    },

    getAccountFromSF(name) {
        const search = name ? name : "";
        return gwFetchInstance
            .send(TECHPOINT_MMS + "/allSalesForceCustomers", {
                method: POST,
                headers: {
                    "content-type": "application/json",
                },
                body: JSON.stringify({
                    "name": `${search}`,
                    "recordType": ""
                }),
            })
            .then((res) => res.json());
    },


    clearEnvironment(environment) {
        return gwFetchInstance.send(
            TECHPOINT_MMS + "/services/clearEnvironments",
            {
                method: POST,
                headers: {
                    "content-type": "application/json",
                },
                body: JSON.stringify(environment),
            }
        );
    },
    getHandsOnApi() {
        return gwFetchInstance.send(TECHPOINT_BUSINESS_MMS + "/services/handsOnAPI", {
            method: GET,

        }).then(res => res.text());
    },

    getIsCpx() {
        return gwFetchInstance.send(TECHPOINT_MMS + "/services/getCpx", {
            method: GET,

        }).then(res => res.text());
    },

    updateCpx() {
        return gwFetchInstance.send(TECHPOINT_MMS + "/services/updateCpx", {
            method: POST,

        }).then(res => res.text());
    },

    downloadIntelligenceReportByLocation(formData) {
        return gwFetchInstance.send(
            TECHPOINT_MMS + "/externaldownloadpresentation",
            {
                method: POST,
                headers: {
                    "content-type": "application/json",
                },
                body: JSON.stringify(formData),
            }
        );
    },


    downloadIntelligenceReportByPlatform(formData) {
        return gwFetchInstance.send(
            TECHPOINT_MMS + "/externaldownloadpresentationByPlatform",
            {
                method: POST,
                headers: {
                    "content-type": "application/json",
                },
                body: JSON.stringify(formData),
            }
        );
    },
    createEnvironment(environment) {
        const params = new URLSearchParams(environment);
        return gwFetchInstance.send(
            TECHPOINT_MMS + "/services/createEnv?" + params,
            {
                method: POST,
                body: JSON.stringify(environment),
            }
        ).then(async (res) => {
            if (res.status === 503) {
                const errorText = await res.text();
                throw new Error(JSON.stringify({
                    status: 503,
                    message: errorText
                }));
            }
            return res.json();
        });
    },

    createTechnicalEngagement(technicalEngagement) {
        return gwFetchInstance.send(
            TECHPOINT_MMS + "/createTechnicalEngagement",
            {
                method: POST,
                headers: {
                    "content-type": "application/json",
                },
                body: JSON.stringify(technicalEngagement),
            }
        ).then(res=> res.json()).then(obj => {return obj});
    },
    updateTechnicalEngagement(technicalEngagement) {
        return gwFetchInstance.send(
            TECHPOINT_MMS + "/updateTechnicalEngagement",
            {
                method: POST,
                headers: {
                    "content-type": "application/json",
                },
                body: JSON.stringify(technicalEngagement),
            }
        );
    },
    getThreatGuardCustomers(customers) {
        const params = new URLSearchParams(customers);
        return gwFetchInstance.send(
            TECHPOINT_BUSINESS_MMS + "/services/customers?" + params ,
            {
                method: POST,
                headers: {
                    "content-type": "application/json",
                },
            }
        ).then(res=> res.json());
    },
    getThreatGuardOpportunities(opportunities) {
        const params = new URLSearchParams(opportunities);
        return gwFetchInstance.send(
            TECHPOINT_BUSINESS_MMS + "/services/opportunities?" + params ,
            {
                method: POST,
                headers: {
                    "content-type": "application/json",
                },
            }
        ).then(res=> res.json());
    },
    sendThreatGuardReport(formData) {
        const params = new URLSearchParams(formData);
        return gwFetchInstance.send(
            TECHPOINT_MMS + "/services/sendThreatGuardReport?" + params,
            {
                method: GET,
                headers : {
                    "content-type": "application/json",
                },
            }
        )
    },
    contentCreated(formData, contentType="ThreatGuard") {
        const request = {
            contentType:`${contentType} content`,
            data: JSON.stringify(formData)
        }
        return gwFetchInstance.send(
            TECHPOINT_MMS + "/services/contentCreated" ,
            {
                method: POST,
                headers : {
                    "content-type": "application/json",
                },
                body: JSON.stringify(request),
            }
        ).then(res => res.json());
    },
    sendReport(request) {
        const params = new URLSearchParams(request);
        return gwFetchInstance.send(
            TECHPOINT_MMS + "/management/sendEnvironmentsReport?"+params ,
            {
                method: GET,
                headers : {
                    "content-type": "application/json",
                },
            }
        ).then(res => res.ok);
    },
    getDepartmentId() {
        return gwFetchInstance.send(
            TECHPOINT_BUSINESS_MMS + "/department_id",
            {
                method: GET,
            }
        ).then(res => res.json());
    },

    getPartners() {
        return gwFetchInstance
            .send(TECHPOINT_BUSINESS_MMS + "/user/partners", { method: GET })
            .then(res => res.json());
    },

    getUCAccounts() {
        return gwFetchInstance
            .send(TECHPOINT_BUSINESS_MMS + "/user/accounts", { method: GET })
            .then(res => res.json());
    },

    getDealRegistrationsByPartnerAndAccount(partnerId, accountId) {
        return gwFetchInstance
            .send(TECHPOINT_BUSINESS_MMS + `/deals/partners/${partnerId}/accounts/${accountId}/deal-registrations`, { method: GET })
            .then(res => res.json());
    }

};


export default apiService;
